export default __webpack_public_path__ + "static/media/software_dev.15a6f7c6.svg";